// extracted by mini-css-extract-plugin
module.exports = {"RitualEmbed":"RitualEmbed_RitualEmbed__ePqWa","closeButton":"RitualEmbed_closeButton__P5_pg"};